import { newE2EPage } from "@stencil/core/testing";

describe("<uic-switch>", () => {
    it("should emit uicChange when checked state changes via click", async () => {
        const page = await newE2EPage({
            html: `<uic-switch></uic-switch>`,
        });
        const switchEl = await page.find("uic-switch");
        const uicChange = await switchEl.spyOnEvent("uicChange");

        await switchEl.click();
        await page.waitForChanges();

        expect(uicChange).toHaveReceivedEventTimes(1);
    });

    it("should not emit uicChange when setting programmatically", async () => {
        const page = await newE2EPage({
            html: `<uic-switch></uic-switch>`,
        });
        const switchEl = await page.find("uic-switch");
        const uicChange = await switchEl.spyOnEvent("uicChange");

        switchEl.setProperty("checked", true);
        await page.waitForChanges();

        expect(uicChange).toHaveReceivedEventTimes(0);
    });
});
